/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigNoContentResponse,
  BboBranchConfigUnauthorizedResponse,
  GetDenominationLadderResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get denomination ladder details
 * @summary Get denomination ladder details
 */
export const getDenominationLadderDetails = (signal?: AbortSignal) => {
  return customInstance<GetDenominationLadderResponseResponse | BboBranchConfigNoContentResponse>({
    url: `/BboBranchConfigService/v1/pouch/denominations`,
    method: 'get',
    signal,
  });
};

export const getGetDenominationLadderDetailsQueryKey = () => {
  return [`/BboBranchConfigService/v1/pouch/denominations`] as const;
};

export const getGetDenominationLadderDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDenominationLadderDetails>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDenominationLadderDetails>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDenominationLadderDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDenominationLadderDetails>>> = ({
    signal,
  }) => getDenominationLadderDetails(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDenominationLadderDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDenominationLadderDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDenominationLadderDetails>>
>;
export type GetDenominationLadderDetailsQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get denomination ladder details
 */
export const useGetDenominationLadderDetails = <
  TData = Awaited<ReturnType<typeof getDenominationLadderDetails>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDenominationLadderDetails>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDenominationLadderDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
